module.exports = __webpack_public_path__ + "static/img/top.cd1f7b1a.png";